import { Component, OnInit, Input, Injector, ChangeDetectorRef } from '@angular/core';
import { RoutingConfig } from '@app/routing/routing.config';
import { DevicesClass, DeviceTypes } from '@app/core/classes/component/devices.class';
import { MenuDataModel } from '@app/core/models/menu';

@Component({
  selector: 'shared-footer-menu',
  templateUrl: 'footer-menu.component.html',
  styleUrls: [`./footer-menu.component.scss`],
})

export class FooterMenuComponent extends DevicesClass implements OnInit {
  public Routing = RoutingConfig;
  public MenuFooter: MenuDataModel = this.onFooterMenuData();

  @Input() Device: DeviceTypes;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onFooterMenuData(): MenuDataModel {
    return [
      {
        title: 'Как стать партнером',
        url: '/' + RoutingConfig.Pages + '/' + RoutingConfig.BecomePartner
      },
      {
        title: 'Техподдержка',
        url: '/' + RoutingConfig.Pages + '/' + RoutingConfig.Contacts
      },
      {
        title: 'Реклама на сайте',
        url: '/' + RoutingConfig.Pages + '/' + RoutingConfig.Advertisement
      },
      {
        title: 'Контактная информация',
        url: '/' + RoutingConfig.Pages + '/' + RoutingConfig.Contacts
      }
    ]
  }
}
